<template>
    <div class="saveOrUpdateCrud descriptionsForm">
        <div>
            <el-page-header @back="close" content="认领入住协议登记"></el-page-header>
        </div>
        <el-form :model="upsertForm"  :rules="rules" ref="upsertForm" label-width="80px" style="margin-top: 20px;" :inline="true" >
            <el-descriptions class="margin-top" :column="2" border size="mini" :labelStyle="{'width':'100px'}">
                <input type="hidden" :value="upsertForm.id">
                <el-descriptions-item>
                    <template slot="label">
                        <span style="color: #F56C6C;margin-right: 4px;">*</span>入住店面
                    </template>
                    <el-form-item prop="hotelId">
                        <el-select size="mini" filterable v-model="upsertForm.hotelId" placeholder="请选择入住店面">
                            <el-option v-for="item in hotelList" :key="item.id" :label="item.title" :value="item.id" @click.native="setHotelName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span style="color: #F56C6C;margin-right: 4px;">*</span>房号
                    </template>
                    <el-form-item prop="houseName">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.houseName" placeholder="请输入房号" auto-complete="off"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span style="color: #F56C6C;margin-right: 4px;">*</span>签字照片
                    </template>
                    <div>
                        <el-image style="width: 100px; height: 100px" v-if="upsertForm.writeName" :src="config.resPre+upsertForm.writeName" :preview-src-list="[config.resPre+upsertForm.writeName]"></el-image>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        查看协议
                    </template>
                    <div>
                        <el-button @click="lookCheck" type="primary">点击查看协议</el-button>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item :span="2">
                    <template slot="label">
                        认领备注
                    </template>
                    <el-form-item prop="remark">
                        <el-input size="mini" maxlength="255" type="textarea" resize="none" :rows="3" v-model="upsertForm.remark" placeholder="请输入认领备注" auto-complete="off"></el-input>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
            <el-table border size="mini" :stripe="true" :data="upsertForm.sysHotelCheckHistories">
                <el-table-column show-overflow-tooltip prop="name" label="客户姓名"></el-table-column>
                <el-table-column show-overflow-tooltip prop="idCard" label="身份证号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="phone" label="联系方式"></el-table-column>
                <el-table-column show-overflow-tooltip prop="f" label="身份证正面照片">
                    <template slot-scope="scope">
                        <el-image style="width: 100px; height: 100px" v-if="scope.row.idCardFrontImg" :src="config.resPre+scope.row.idCardFrontImg" :preview-src-list="[config.resPre+scope.row.idCardFrontImg]"></el-image>
                    </template>
                </el-table-column>
<!--                <el-table-column show-overflow-tooltip prop="healthCodeImg" label="健康码照片">-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-image style="width: 100px; height: 100px" v-if="scope.row.healthCodeImg" :src="config.resPre+scope.row.healthCodeImg" :preview-src-list="[config.resPre+scope.row.healthCodeImg]"></el-image>-->
<!--                    </template>-->
<!--                </el-table-column>-->
              <!--  <el-table-column show-overflow-tooltip prop="idCardReverseImg" label="身份证反面照片">
                    <template slot-scope="scope">
                        <el-image style="width: 100px; height: 100px" v-if="scope.row.idCardReverseImg" :src="config.resPre+scope.row.idCardReverseImg" :preview-src-list="[config.resPre+scope.row.idCardReverseImg]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="runCodeImg" label="行程码照片">
                    <template slot-scope="scope">
                        <el-image style="width: 100px; height: 100px" v-if="scope.row.runCodeImg" :src="config.resPre+scope.row.runCodeImg" :preview-src-list="[config.resPre+scope.row.runCodeImg]"></el-image>
                    </template>
                </el-table-column>-->
                <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable="custom"></el-table-column>
            </el-table>
        </el-form>
        <div class="dialog-footer" style="text-align: center;margin-top: 20px;">
            <el-button plain size="mini" @click="close">取 消</el-button>
            <el-button plain size="mini" type="primary" v-display:sysHotelCheck-update @click="saveOrUpdate('upsertForm')">确 定 认 领</el-button>
        </div>
        <el-dialog :close-on-click-modal="false" title="协议内容"   width="650px" :visible.sync="look">
            <div v-if="content" v-html="content" style="height: 40rem;overflow-y: auto">

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" @click="look = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
    import axios from 'axios'
    let loading;
    export default {
        name: "saveOrUpdateSysHotelChecks",
        props: ['title','id',"agreementId"],
        data(){
            return {
                upsertForm:{
                    adminId: '',
                    adminName: '',
                    agreementId: '',
                    hotelId: '',
                    hotelName: '',
                    houseName: '',
                    names: '',
                    phones: '',
                    idCards: '',
                    userAgent: '',
                    browser: '',
                    os: '',
                    status: '',
                    startTime: '',
                    endTime: '',
                    days: '',
                    writeName: '',
                    claimTime: '',
                    claimAdminId: '',
                    claimAdminName: '',
                    remark:'',
                    updateTime: '',
                    createTime: '',
                },
                rules: {
                    adminId: [
                        {required: true, message: '请输入操作人编', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    adminName: [
                        {required: true, message: '请输入操作人名', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    hotelId: [
                        {required: true, message: '请选择酒店', trigger: 'blur'},
                    ],
                    hotelName: [
                        {required: true, message: '请输入入住店面', trigger: 'blur'},
                    ],
                    houseName: [
                        {required: true, message: '请输入房号', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: '请输入姓名', trigger: 'blur'},
                        {max: 20, message: '长度必须少于20个字符', trigger: 'blur'}
                    ],
                    idCard: [
                        {required: true, message: '请输入身份证号', trigger: 'blur'},
                        {max: 18, message: '长度必须少于18个字符', trigger: 'blur'}
                    ],
                    phone: [
                        {required: true, message: '请输入联系方式', trigger: 'blur'},
                        {max: 11, message: '长度必须少于11个字符', trigger: 'blur'}
                    ],
                    idCardFrontImg: [
                        {required: true, message: '请上传身份证正面照片', trigger: 'blur'},
                    ],
                    idCardReverseImg: [
                        {required: true, message: '请上传身份证反面照片', trigger: 'blur'},
                    ],
                    healthCodeImg: [
                        {required: true, message: '请上传健康码照片', trigger: 'blur'},
                    ],
                    runCodeImg: [
                        {required: true, message: '请上传行程码照', trigger: 'blur'},
                    ],
                    userAgent: [
                        {required: true, message: '请输入设备', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    browser: [
                        {required: true, message: '请输入浏览器', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    os: [
                        {required: true, message: '请输入操作系统', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    status: [
                        {required: true, message: '请输入状态，0', trigger: 'blur'},
                    ],
                    startTime: [
                        {required: true, message: '请选择入住时间', trigger: 'blur'},
                    ],
                    endTime: [
                        {required: true, message: '请输入结束时间', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    days: [
                        {required: true, message: '请输入入住天数', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    updateTime: [
                        {required: true, message: '请输入修改时间', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                    createTime: [
                        {required: true, message: '请输入创建时间', trigger: 'blur'},
                        {max: 32, message: '长度必须少于32个字符', trigger: 'blur'}
                    ],
                },
                config:config,
                uploadHotelCheckUrl:`${home}/sysHotelCheck/uploadHotelCheck`,
                hotelList:[],
                look:false,
                content:'',
            }
        },
        created(){
            this.findHotelList();
            axios({
                url: `${home}/sysHotelCheck/update/findSysHotelCheckById/${this.id}`,
                method: 'GET'
            }).then(res => {
                Object.assign(this.upsertForm, res.data);
                if(this.upsertForm.startTime && this.upsertForm.endTime){
                    this.upsertForm.startTime = (this.upsertForm.startTime+"~"+this.upsertForm.endTime).split("~");
                }
            }).catch(error => {
            });
        },
        mounted(){

        },
        methods:{
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        if(this.upsertForm.startTime){
                            this.upsertForm.endTime = this.upsertForm.startTime[1];
                            this.upsertForm.startTime = this.upsertForm.startTime[0];
                        }
                        axios({
                            url:`${home}/sysHotelCheck/claimSysHotelCheck`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: '认领成功',
                                type: 'success'
                            });
                            this.close();
                        }).catch(error=>{
                            //do something
                        })
                    }
                })
            },
            close(){
                this.$emit('closeSaveChecks');
            },
            uploadIdCardFrontImgSuccess(response, file, fileList){
                this.upsertForm.idCardFrontImg=response;
                loading.close();
            },
            beforeHotelCheckUpload(file){
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                const extension = file.name.split(".")[1] === "png";
                const extension2 = file.name.split(".")[1] === "jpg";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 png,jpg 格式!");
                }
                return extension || extension2;
            },
            hotelCheckUploadProgress(event, file, fileList){

            },
            uploadHotelCheckError(err, file, fileList){
                loading.close();
            },
            uploadIdCardReverseImgSuccess(response, file, fileList){
                this.upsertForm.idCardReverseImg=response;
                loading.close();
            },
            uploadHealthCodeImgSuccess(response, file, fileList){
                this.upsertForm.healthCodeImg=response;
                loading.close();
            },
            uploadRunCodeImgSuccess(response, file, fileList){
                this.upsertForm.runCodeImg=response;
                loading.close();
            },
            setHotelName(e){
                this.upsertForm.hotelName = e.target.innerText;
            },
            findHotelList(){
                axios({
                    url: `${home}/sysDdList/findSysShopManageAllList/${this.agreementId}`,
                    method: "GET",
                }).then(res => {
                    this.hotelList = res.data;
                }).catch(error => {
                });
            },
            lookCheck(){
                axios({
                    url: `${home}/sysDdList/findCheckInfo/${this.upsertForm.agreementId}`,
                    method: "GET"
                }).then(res => {
                    this.content = res.data.content;
                    this.look = true;
                }).catch(error => {

                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .saveOrUpdateCrud{
        margin: 20px 0 0 10px;
    }
</style>
